import React, { memo, useState } from 'react';
import { Blok } from '../../../../../../interfaces/Blok.interface';
import ContactMethodFactory from '../ContactMethodFactory/ContactMethodFactory';
import { graphql, useStaticQuery } from 'gatsby';
import SbImage from '../../../../../SbImage/SbImage';
import Heading, { HeadingTypes } from '../../../../../Heading/Heading';
import RichText from '../../../../../RichText/RichText';
import Modal from '../../../../../Modal/Modal';
import ButtonLink from '../../../../../ButtonLink/ButtonLink';
import { ButtonType } from '../../../../../../interfaces/enums/ButtonType.enum';
import { ButtonSize } from '../../../../../../interfaces/enums/ButtonSize.enum';

interface WhatsappBlokProps extends Blok {
  label: string;
  something_tbc: string;
}

interface WhatsappProps {
  blok: WhatsappBlokProps;
}

const Whatsapp: React.FC<WhatsappProps> = ({ blok, ...props }) => {
  const { label, something_tbc } = blok;
  const [onPopupOpen, setOnPopupOpen] = useState<boolean>(false);
  const { whatsapp_info } = useStaticQuery(graphql`
    {
      whatsapp_info: allStoryblokEntry(
        filter: { field_component: { eq: "whatsapp_info" } }
      ) {
        edges {
          node {
            id
            name
            created_at
            uuid
            slug
            full_slug
            content
            is_startpage
            parent_id
            group_id
            field_component
            published_at
          }
        }
      }
    }
  `);

  const { qr_code, logo, heading, instructions } = JSON.parse(
    whatsapp_info.edges[0].node.content
  );

  return (
    <>
      <Modal toggleModal={onPopupOpen} onClose={setOnPopupOpen}>
        <div className="bg-system/white rounded-2xl text-center space-y-4 2xl:space-y-6 px-4 py-4 sm:py-8 2xl:py-16 sm:px-12 2xl:px-24 relative">
          <div className="flex justify-center">
            {logo?.filename && (
              <SbImage
                asset={logo}
                options={{
                  width: 200,
                  sizes: { base: 200 },
                }}
              />
            )}
          </div>
          {qr_code?.filename && (
            <SbImage
              asset={qr_code}
              options={{
                width: 270,
                sizes: { base: 220, sm: 270 },
                className: '!w-[140px] sm:!w-[170px] 2xl:!w-[190px]',
              }}
            />
          )}
          <Heading
            text={heading}
            headingType={HeadingTypes.h3}
            headingStyleType={HeadingTypes.h4}
          />
          <div className="flex text-left">
            <div className="">
              <RichText content={instructions} />
            </div>
          </div>
          <button
            className="h-[24px] w-[24px] bg-no-repeat bg-system/black absolute -top-4 right-3 block sm:hidden"
            aria-label="close menu"
            onClick={() => setOnPopupOpen(false)}
            style={{
              WebkitMaskImage: "url('/svgs/close.svg')",
              maskImage: "url('/svgs/close.svg')",
            }}
          />
        </div>
      </Modal>

      <ContactMethodFactory
        icon_url={'/svgs/move-specialist-whatsapp-contact-icon.svg'}
        url={something_tbc}
        label={label}
        openModal={setOnPopupOpen}
        isModal
      />
    </>
  );
};

export default memo(Whatsapp);
